import type { FC } from "react";

import { transformCustomsClassificationsOptions } from "../../../../../common/graphql/useCustomsClassificationsOptions";
import { getMaybeDateFromDateAndTime } from "../../../../../common/utils/dates/dateUtils";
import { useUpdateFormStateMinimalBooking } from "../../../../../common/utils/minimalBooking";
import { transformCustomsClassificationOption } from "../../../../../common/utils/optionTransformers";
import { DropdownField } from "./DropdownField";

export interface CustomsClassificationFieldProps {
  disabled: boolean;
  id?: string;
}

export const CustomsClassificationField: FC<
  CustomsClassificationFieldProps
> = ({ disabled, ...props }) => {
  const minimalBooking = useUpdateFormStateMinimalBooking();

  if (!minimalBooking) {
    return null;
  }

  const customsClassifications =
    minimalBooking?.route?.ukCustomsClassifications;
  const includeEmptyOption = !minimalBooking.customsClassificationCode;

  return (
    <DropdownField
      trackerCategory={"Details"}
      disabled={disabled}
      transformOption={transformCustomsClassificationOption}
      name={"customsClassification"}
      options={transformCustomsClassificationsOptions(
        customsClassifications,
        getMaybeDateFromDateAndTime(
          minimalBooking.departureDate,
          minimalBooking.departureTime,
        ),
        includeEmptyOption,
      )}
      {...props}
    />
  );
};
